/** Fallback only - the radius shown on initial load comes from the Super Admin global settings. */
export const DEFAULT_TRACKING_RADIUS_MILES = 50;

/** Layers that own their query and report their loading state to the container. */
export enum TrackingMapLayer {
  JOBS = 'jobs',
  CUSTOMERS = 'customers',
  MOBILE_USERS = 'mobileUsers'
}

/** Loading-panel rows whose state the container already holds. */
export enum TrackingLoadingRow {
  MAP_SETTINGS = 'mapSettings',
  EQUIPMENT = 'equipment'
}

/** Every row of the map's loading panel, in display order. */
export const TRACKING_LOADING_ROWS: {
  key: TrackingLoadingRow | TrackingMapLayer;
  label: string;
}[] = [
  { key: TrackingLoadingRow.MAP_SETTINGS, label: 'Map settings' },
  { key: TrackingLoadingRow.EQUIPMENT, label: 'Equipment' },
  { key: TrackingMapLayer.JOBS, label: 'Jobs' },
  { key: TrackingMapLayer.CUSTOMERS, label: 'Customers' },
  { key: TrackingMapLayer.MOBILE_USERS, label: 'Mobile Users' }
];

export enum EquipmentBreadCrumb {
  BREADCRUMS_OFF = 1,
  BREADCRUM_ONLY = 2,
  BREADCRUMS_AND_LINES = 3,
  // Path lines shown without breadcrumb pins.
  // Added so History and Breadcrumbs can be toggled independently.
  LINES_ONLY = 4
}

/** True when the breadcrumb pins should be rendered for the given value. */
export const breadCrumbHasBreadcrumbs = (value?: EquipmentBreadCrumb): boolean =>
  value === EquipmentBreadCrumb.BREADCRUM_ONLY ||
  value === EquipmentBreadCrumb.BREADCRUMS_AND_LINES;

/** True when the path lines should be rendered for the given value. */
export const breadCrumbHasLines = (value?: EquipmentBreadCrumb): boolean =>
  value === EquipmentBreadCrumb.BREADCRUMS_AND_LINES || value === EquipmentBreadCrumb.LINES_ONLY;

/** Collapse the two independent toggles back into the enum value. */
export const buildBreadCrumbValue = ({
  lines,
  breadcrumbs
}: {
  lines: boolean;
  breadcrumbs: boolean;
}): EquipmentBreadCrumb => {
  if (lines && breadcrumbs) return EquipmentBreadCrumb.BREADCRUMS_AND_LINES;
  if (lines) return EquipmentBreadCrumb.LINES_ONLY;
  if (breadcrumbs) return EquipmentBreadCrumb.BREADCRUM_ONLY;

  return EquipmentBreadCrumb.BREADCRUMS_OFF;
};
